import React from "react";
import PropTypes from "prop-types";
import "./HelperContent.css";
import { isMobile, isTablet, isIOS, isAndroid } from "react-device-detect";
import { has, get } from 'lodash';

const appCfg = require("../../config");

const HelperContent = ({ question }) => {
    let helperTextTag, helperImageTag;
    let textColor =
        question.helperTextColor && question.helperTextColor.trim().length > 0
            ? " w3-text-" + question.helperTextColor
            : " w3-text-black";
    let helperTextClassNames = "w3-center question-helper-text w3-padding" + textColor;
    
    let helperText;
    if (has(question, "helperText") || has(question, "mobileHelperText") || has(question, "desktopHelperText")) {
        if (has(question, "helperText")) {
            helperText = get(question, "helperText");
        }
        if (has(question, "mobileHelperText") && (isMobile || isTablet || isIOS || isAndroid)) {
            helperText = get(question, "mobileHelperText");
        }
        if (has(question, "desktopHelperText") && !isMobile && !isTablet && !isIOS && !isAndroid) {
            helperText = get(question, "desktopHelperText");
        }
    }

    if (helperText && helperText.trim().length > 0) {
        helperTextTag = <div className={helperTextClassNames} style={{ whiteSpace: 'pre-wrap' }}>{helperText}</div>;
    }

    let helperImage;
    if (has(question, "helperImage") || has(question, "mobileHelperImage") || has(question, "desktopHelperImage")) {
        if (has(question, "helperImage")) {
            helperImage = get(question, "helperImage");
        }
        if (has(question, "mobileHelperImage") && (isMobile || isTablet || isIOS || isAndroid)) {
            helperImage = get(question, "mobileHelperImage");
        }
        if (has(question, "desktopHelperImage") && !isMobile && !isTablet && !isIOS && !isAndroid) {
            helperImage = get(question, "desktopHelperImage");
        }
    }

    if (helperImage && helperImage.trim().length > 0) {
        helperImageTag = (
            <div className="w3-padding">
                <img
                    className="question-helper-image"
                    src={appCfg.customerImageUrlPrefix + "/" + helperImage}
                    alt="Helper Img"
                />
            </div>
        );
    }

    return (
        <div className="form w3-header w3-animate-opacity">
            {helperTextTag}
            {helperImageTag}
        </div>
    );
};

HelperContent.propTypes = {
    question: PropTypes.object
};

export default HelperContent;
